import { PermissionsRolesEnum } from "@/enums"
const PERMISSION_ROLES = {
  DASHBOARD: [
    PermissionsRolesEnum.ADMIN,
    PermissionsRolesEnum.DASHBOARD_READ,
  ],
  DEFAULTERS: [
    PermissionsRolesEnum.ADMIN,
    PermissionsRolesEnum.SALES_READ,
  ],
  ORDERS: [
    PermissionsRolesEnum.ADMIN,
    PermissionsRolesEnum.ORDERS_READ,
    PermissionsRolesEnum.ORDERS_WRITE,
  ],
  SALES: [
    PermissionsRolesEnum.ADMIN,
    PermissionsRolesEnum.SALES_READ,
  ],
  SUBSCRIPTIONS: [
    PermissionsRolesEnum.ADMIN,
    PermissionsRolesEnum.SUBSCRIPTIONS_READ,
    PermissionsRolesEnum.SUBSCRIPTIONS_WRITE,
  ],
  SCHEDULE: [
    PermissionsRolesEnum.ADMIN,
    PermissionsRolesEnum.SCHEDULE_READ,
  ],
  ACCESS_MANAGEMENT: [PermissionsRolesEnum.ADMIN],
  LOGIN: [],
  FORGOT_PASSWORD: [],
  SSO_LOGIN_FORM: [],
  FIRST_LOGIN: [],
  RECOVERY_PASSWORD: [],
  NOTIFICATION_CENTER: [PermissionsRolesEnum.ADMIN],
  WEBHOOKS: [PermissionsRolesEnum.ADMIN],
  REPIC_CENTER: [PermissionsRolesEnum.ADMIN],
  CUSTOMERS: [
    PermissionsRolesEnum.ADMIN,
    PermissionsRolesEnum.CUSTOMERS_READ,
    PermissionsRolesEnum.CUSTOMERS_WRITE,
  ],
  SMART_ROUTING: [PermissionsRolesEnum.ADMIN],
  ADMIN_REPROCESS: [PermissionsRolesEnum.ADMIN],
  ADMIN_PROCESSOR_CONFIG: [PermissionsRolesEnum.ADMIN],
  ADMIN_WHITE_LABELS: [PermissionsRolesEnum.ADMIN],
  ADMIN_MERCHANTS: [PermissionsRolesEnum.ADMIN],
  ADMIN_WEBHOOK_INBOX: [PermissionsRolesEnum.ADMIN],
} as const
export default PERMISSION_ROLES
